<template>
  <div
    v-if="showLoadingState < 1"
    key="loadingState"
  >
    <AtomLoadingPrimary/>
  </div>
  <div
    v-else
    key="HomeLanding"
  >
    <div class="m-home-landing-access">
      <h1>{{ title }}</h1>
      <h2>{{ subtitle }}</h2>

      <div class="m-home-landing-access-sections">
        <router-link
          :to="`/${$t('rPaths.academy')}/${$t('mEditionMenu.academy.users.subject')}`"
          class="m-card-primary m-card-transition m-home-landing-access-section-item"
          :class="{ 'm-home-landing-access-section-item-academy': estados[1] }"
          tag="div"
        >
          <h2 class="m-home-landing-access-section-item-number text-color-academy-primary">
            1
          </h2>
          <div class="item-img">
            <img
              :class="{ 'item-img-not-active': !estados[1] }"
              src="@/assets/img/home/home-academy.png"
            />
          </div>
          <div>
            <h3 class="text-color-academy-primary">
              {{ $t('mHomeLandingAccess.academyAccess.title') }}
            </h3>
            <p>
              {{ $t('mHomeLandingAccess.academyAccess.paragraph') }}
            </p>
          </div>
          <p
            class="font-weight-bold m-home-landing-access-section-item-text"
            :class="{ 'text-color-academy-primary': estados[1] }"
          >
            <template v-if="estados[1]">
              {{ $t('mHomeLandingAccess.state.ready') }}
              <span>
                <i class="fas fa-check"></i>
              </span>
            </template>
            <template v-else>
              {{ $t('mHomeLandingAccess.state.pending') }}
              <span>
                <i class="fa fa-check fa-blank"></i>
              </span>
            </template>
          </p>
        </router-link>

        <router-link
          :to="`/${$t('rPaths.billing')}/${$t('mEditionMenu.billing.mySales.subject')}`"
          class="m-card-primary m-card-transition m-home-landing-access-section-item"
          :class="{ 'm-home-landing-access-section-item-billing': estados[0] }"
          tag="div"
        >
          <h2 class="text-color-billing-primary">
            2
          </h2>
          <div class="item-img">
            <img
              :class="{ 'item-img-not-active': !estados[0] }"
              src="@/assets/img/home/home-billing.png"
            />
          </div>
          <div>
            <h3 class="text-color-billing-primary">
              {{ $t('mHomeLandingAccess.billingAccess.title') }}
            </h3>
            <p>
              {{ $t('mHomeLandingAccess.billingAccess.paragraph') }}
            </p>
          </div>
          <p
            class="m-home-landing-access-section-item-text"
            :class="{ 'text-color-billing-primary': estados[0] }"
          >
            <template v-if="estados[0]">
              {{ $t('mHomeLandingAccess.state.ready') }}
              <span>
                <i class="fas fa-check"></i>
              </span>
            </template>
            <template v-else>
              {{ $t('mHomeLandingAccess.state.pending') }}
              <span>
                <i class="fa fa-check fa-blank"></i>
              </span>
            </template>
          </p>
        </router-link>

        <router-link
          :to="`/${$t('rPaths.projects')}`"
          class="m-card-primary m-card-transition m-home-landing-access-section-item"
          :class="{ 'm-home-landing-access-section-item-projects': estados[2] }"
          tag="div"
        >
          <h2 class="m-home-landing-access-section-item-number text-color-projects-primary">
            3
          </h2>
          <div class="item-img">
            <img
              :class="{ 'item-img-not-active': !estados[2] }"
              src="@/assets/img/home/home-assets.png"
            />
          </div>
          <div>
            <h3 class="text-color-projects-primary">
              {{ $t('mHomeLandingAccess.projectsAccess.title') }}
            </h3>
            <p>
              {{ $t('mHomeLandingAccess.projectsAccess.paragraph') }}
            </p>
          </div>
          <p
            class="font-weight-bold m-home-landing-access-section-item-text"
            :class="{ 'text-color-assets-primary': estados[2] }"
          >
            <template v-if="estados[2]">
              {{ $t('mHomeLandingAccess.state.ready') }}
              <span>
                <i class="fas fa-check"></i>
              </span>
            </template>
            <template v-else>
              {{ $t('mHomeLandingAccess.state.pending') }}
              <span>
                <i class="fa fa-check fa-blank"></i>
              </span>
            </template>
          </p>
        </router-link>

        <router-link
          :to="`/${$t('rPaths.products')}`"
          class="m-card-primary m-card-transition m-home-landing-access-section-item"
          :class="{ 'm-home-landing-access-section-item-products': estados[3] }"
          tag="div"
        >
          <h2 class="m-home-landing-access-section-item-number text-color-products-primary">
            4
          </h2>
          <div class="item-img">
            <img
              :class="{ 'item-img-not-active': !estados[3] }"
              src="@/assets/img/home/home-products.png"
            />
          </div>
          <div>
            <h3 class="text-color-products-primary">
              {{ $t('mHomeLandingAccess.productsAccess.title') }}
            </h3>
            <p>
              {{ $t('mHomeLandingAccess.productsAccess.paragraph') }}
            </p>
          </div>
          <p
            class="font-weight-bold m-home-landing-access-section-item-text"
            :class="{ 'text-color-products-primary': estados[3] }"
          >
            <template v-if="estados[3]">
              {{ $t('mHomeLandingAccess.state.ready') }}
              <span>
                <i class="fas fa-check"></i>
              </span>
            </template>
            <template v-else>
              {{ $t('mHomeLandingAccess.state.pending') }}
              <span>
                <i class="fa fa-check fa-blank"></i>
              </span>
            </template>
          </p>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeHomeLandingAccess',

  data () {
    return {
      configuracionGlobal: {
        academia: {
          datosGenerales: false,
          datosDePersona: false,
          textosLegales: false
        },

        gestion: {
          mediosDePago: false,
          puntosDeVenta: false
        },

        proyectos: false,
        productos: false
      },

      estados: [],
      showLoadingState: 0,
      subtitle: '',
      title: ''
    }
  },

  computed: {
    academiaId () {
      return this.$store.getters.getAcademyData.id
    },

    usuario () {
      let usuarioAux = this.$store.getters.getUserData
      return usuarioAux.vidroop_data &&
        usuarioAux.vidroop_data.persona &&
        usuarioAux.vidroop_data.persona.razon_social
        ? usuarioAux.vidroop_data.persona.razon_social.substr(
          0, usuarioAux.vidroop_data.persona.razon_social.indexOf(' '))
        : ''
    }
  },

  watch: {
    academiaId () {
      this.readAcademiaConfiguracionGlobal()
    }
  },

  created () {
    this.readAcademiaConfiguracionGlobal()
  },

  methods: {
    readAcademiaConfiguracionGlobal () {
      this.showLoadingState = 0
      this.estados = []
      this.$services.read('academia', 'readAcademiaConfiguracionGlobal', {}, [this.academiaId])
        .then(response => {
          this.configuracionGlobal = Object.assign({}, response.data)
          this.$store.commit('setAcademyGlobalConfiguration', Object.assign({}, response.data))
          this.estados[0] = this.configuracionGlobal.gestion.mediosDePago &&
            this.configuracionGlobal.gestion.puntosDeVenta
          this.estados[1] = this.configuracionGlobal.academia.datosGenerales &&
            this.configuracionGlobal.academia.datosDePersona &&
            this.configuracionGlobal.academia.textosLegales
          this.estados[2] = this.configuracionGlobal.proyectos
          this.estados[3] = this.configuracionGlobal.productos
          this.estados[4] = this.estados.every(Boolean)

          if (this.estados.every(Boolean)) {
            this.title = this.$t('mHomeLandingAccess.title.done') + ' ' + this.usuario
            this.subtitle = this.$t('mHomeLandingAccess.subtitle.done')
          } else if (this.estados.every(v => v === false)) {
            this.title = this.$t('mHomeLandingAccess.title.initial') + ' ' + this.usuario
            this.subtitle = this.$t('mHomeLandingAccess.subtitle.initial')
          } else {
            this.title = this.$t('mHomeLandingAccess.title.notDone') + ' ' + this.usuario
            this.subtitle = this.$t('mHomeLandingAccess.subtitle.notDone')
          }
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    }
  }
}
</script>
